/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Pit3_TInputs */

const en_to_xml_pit3_t = /** @type {(inputs: To_Xml_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No namespaces are emitted`)
};

const ko_to_xml_pit3_t = /** @type {(inputs: To_Xml_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네임스페이스는 출력되지 않습니다`)
};

const ja_to_xml_pit3_t = /** @type {(inputs: To_Xml_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前空間は出力されません`)
};

/**
* | output |
* | --- |
* | "No namespaces are emitted" |
*
* @param {To_Xml_Pit3_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_pit3_t = /** @type {((inputs?: To_Xml_Pit3_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Pit3_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_pit3_t(inputs)
	if (locale === "ko") return ko_to_xml_pit3_t(inputs)
	return ja_to_xml_pit3_t(inputs)
});